import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { safeHtml } from "../lib/sanitize";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function ReviewPage() {
  const { slug } = useParams();
  const [r, setR] = useState(null);
  useEffect(() => { api.get(`/reviews/slug/${slug}`).then((res) => setR(res.data)).catch(() => {}); }, [slug]);
  if (!r) return (<div className="min-h-screen"><Header /><div className="container-page py-24">Loading…</div></div>);
  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Header />
      <article className="container-page py-12 md:py-16 max-w-4xl" data-testid="review-page">
        <Link to="/reviews" className="overline text-[#4A4742]">← Reviews</Link>
        <div className="overline text-[#B4533C] mt-6">{r.review_type} Review</div>
        <h1 className="font-serif text-4xl md:text-6xl tracking-tight mt-3">{r.brand_name}</h1>
        <h2 className="font-serif text-2xl md:text-3xl text-[#4A4742] mt-2">{r.product_name}</h2>
        <div className="mt-6 flex items-baseline gap-4">
          <span className="font-mono text-6xl text-[#1B3B36]">{r.rating.toFixed(1)}</span>
          <span className="font-mono text-lg text-[#4A4742]">/ 5.0</span>
        </div>
        {r.featured_image && <div className="mt-10 aspect-[16/9] overflow-hidden border border-[#D6CFC4]"><img src={r.featured_image} alt={r.product_name} className="w-full h-full object-cover" /></div>}
        <div className="mt-10 grid md:grid-cols-2 gap-6">
          <div className="border border-[#D6CFC4] p-6 bg-white" data-testid="review-pros">
            <div className="overline text-[#2D5A4C] mb-3">Pros</div>
            <ul className="space-y-2 text-sm">{r.pros.map((p) => <li key={`pro-${p}`}>+ {p}</li>)}</ul>
          </div>
          <div className="border border-[#D6CFC4] p-6 bg-white" data-testid="review-cons">
            <div className="overline text-[#B4533C] mb-3">Cons</div>
            <ul className="space-y-2 text-sm">{r.cons.map((p) => <li key={`con-${p}`}>− {p}</li>)}</ul>
          </div>
        </div>
        <div className="mt-10 border-l-4 border-[#B4533C] pl-6">
          <div className="overline text-[#B4533C] mb-2">The Verdict</div>
          <p className="font-serif text-2xl md:text-3xl leading-tight">{r.verdict}</p>
        </div>
        <div className="prose-editorial mt-10" dangerouslySetInnerHTML={safeHtml(r.body_rich_text)} />
      </article>
      <Footer />
    </div>
  );
}
